import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useState, useRef, useContext } from 'react';
import { NavContext } from './NavContext';

NavBarCollapsible.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool.isRequired,
};

function NavBarCollapsible({ label, to, children, defaultOpen }) {
  const { setMobileMenu } = useContext(NavContext);
  const contentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <li
      className={`dropdown ${isOpen ? 'open' : ''}`}
      onClick={handleClick}
      role="menuitem"
      onKeyDown={handleClick}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Link
          onClick={() => setMobileMenu(false)}
          className="dropdown-toggle"
          to={to}>
          {label}
        </Link>
        <span>
          <svg
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'all 0.3s ease',
              zIndex: isOpen ? -1 : 'auto',
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 42 43"
            fill="none"
            className="dropdown-icon">
            <path
              d="M33.25 16.1875L21 28.4375L8.75 16.1875"
              stroke="currentColor"
              strokeWidth="4.375"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
      <div
        ref={contentRef}
        className={`dropdown-menu ${isOpen ? 'show' : ''}`}
        style={{
          maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0',
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? 'visible' : 'hidden',
          overflow: 'hidden',
          transition: 'all 0.3s ease-in-out',
        }}>
        <div className="dropdown-content">{children}</div>
      </div>
    </li>
  );
}
export default NavBarCollapsible;
